"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReactiveFilterRangeProps = void 0;
const react_1 = __importDefault(require("react"));
const useReactiveFilterSharedProps_1 = require("./useReactiveFilterSharedProps");
/**
 * For use with @appbaseio/reactivesearch SingleRange and MultiRange components
 */
const useReactiveFilterRangeProps = filter => {
  const reactiveFilterSharedProps = (0, useReactiveFilterSharedProps_1.useReactiveFilterSharedProps)(filter);
  const data = react_1.default.useMemo(() => {
    var _a, _b;
    return (_b = (_a = filter.displayRangeOptions) === null || _a === void 0 ? void 0 : _a.map(option => {
      const [label, start, end] = option.split(":");
      return {
        label: label,
        start: start ? parseInt(start) : 0,
        end: end ? parseInt(end) : Number.MAX_SAFE_INTEGER
      };
    })) !== null && _b !== void 0 ? _b : [];
  }, []);
  const reactiveFilterRangeProps = react_1.default.useMemo(() => {
    var _a, _b;
    return Object.assign(Object.assign({}, reactiveFilterSharedProps), {
      queryFormat: (_a = filter.settingsFilterLogic) !== null && _a !== void 0 ? _a : "or",
      showFilter: (_b = filter.settingsShowFilter) !== null && _b !== void 0 ? _b : true,
      showRadio: false,
      showCheckbox: false,
      data: data
    });
  }, [filter, reactiveFilterSharedProps]);
  return reactiveFilterRangeProps;
};
exports.useReactiveFilterRangeProps = useReactiveFilterRangeProps;